import { OptionsApi } from '@core/swagger-client';
import { CompositePageHeader, ContainerNoTopSpace, ErrorMessagePage, Heading, LoaderPage, PageHeader, PageHeaderContent } from '@core/ui';
import { BackToOriginLink } from '@online-webinar/ui-frontend';
import { useQuery } from '@tanstack/react-query';
import { getRouteApi } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AnalyticsCard } from '../../molecules';
import { SparkLine } from './SparkLine';

const route = getRouteApi('/$webinarId/analytics'); // Replace with the actual route path for webinar analytics
export const WebinarAnalytics = () => {
    const { webinarId } = route.useParams();
    const { t } = useTranslation();
    const { data: webinar, error: webinarError } = useQuery(OptionsApi.webinar.get(webinarId));
    const { data, error: webRtcError, isLoading } = useQuery(OptionsApi.analytics.getWebRtcStatistics(webinarId));

    const error = webinarError || webRtcError;
    if (error) {
        return <ErrorMessagePage apiError={error} />;
    }

    if (isLoading || !data || !webinar) {
        return <LoaderPage />;
    }

    return (
        <ContainerNoTopSpace>
            <PageHeader>
                <PageHeaderContent>
                    <CompositePageHeader title={webinar.title} broadcastDateTime={webinar.broadcastDateTime} />
                </PageHeaderContent>
            </PageHeader>

            <div className="@container px:4 md:px-6 pt-4 md:pt-10 max-w-6xl">
                <BackToOriginLink fallback="insights" />
                <Heading variant="h1" classNames="mb-4 lg:mb-6 2xl:mb-8">
                    {t('WebinarAnalytics.PageHeading')}
                </Heading>

                <div className="grid @min-[40rem]:grid-cols-2 gap-4">
                    <AnalyticsCard heading={t('WebinarAnalytics.Heading.VideoScore')}>
                        <SparkLine data={data} field="videoScore" />
                    </AnalyticsCard>
                    <AnalyticsCard heading={t('WebinarAnalytics.Heading.VideoPackets')}>
                        <SparkLine data={data} field="videoPacketsSent" />
                    </AnalyticsCard>
                    <AnalyticsCard heading={t('WebinarAnalytics.Heading.AudioScore')}>
                        <SparkLine data={data} field="audioScore" />
                    </AnalyticsCard>
                    <AnalyticsCard heading={t('WebinarAnalytics.Heading.AudioPackets')}>
                        <SparkLine data={data} field="audioPacketsSent" />
                    </AnalyticsCard>
                    <AnalyticsCard heading={t('WebinarAnalytics.Heading.PacketDelay')}>
                        <SparkLine data={data} field="packetDelay" />
                    </AnalyticsCard>
                    <AnalyticsCard heading={t('WebinarAnalytics.Heading.RetransmittedPackets')}>
                        <SparkLine data={data} field="retransmittedPacketsSent" />
                    </AnalyticsCard>
                    <AnalyticsCard heading={t('WebinarAnalytics.Heading.BytesSent')}>
                        <SparkLine data={data} field="bytesSent" />
                    </AnalyticsCard>
                </div>
            </div>
        </ContainerNoTopSpace>
    );
};
